import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import "../../styles/projectStyles/AdditionalDetails.css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const AdditionalDetails = () => {
  // Ensure `files` is always an array
  const [files, setFiles] = useState(() => {
    try {
      const savedFiles = JSON.parse(localStorage.getItem("uploadedFiles"));
      return Array.isArray(savedFiles) ? savedFiles : [];
    } catch {
      return [];
    }
  });

  // Function to get the file icon based on extension
  const getFileIcon = (fileName) => {
    const extension = fileName.split(".").pop().toLowerCase();
    switch (extension) {
      case "pdf":
        return "images/icons/pdf.png";
      case "doc":
      case "docx":
        return "images/icons/doc.png";
      case "jpeg":
      case "jpg":
      case "png":
        return "images/icons/image.png";
      case "mp4":
      case "mov":
      case "avi":
        return "images/icons/video.png";
      default:
        return "images/icons/document.png";
    }
  };

  // Handle file uploads
  const onDrop = (acceptedFiles) => {
    const newFiles = acceptedFiles.map((file) => ({
      image: getFileIcon(file.name),
      name: file.name,
      size: `${(file.size / 1024).toFixed(2)} KB`,
      progress: 0,
    }));

    setFiles((prevFiles) => [...prevFiles, ...newFiles]); // Append new files to existing files
  };

  // Handle delete action
  const handleDelete = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  // Save files to localStorage whenever `files` updates
  useEffect(() => {
    localStorage.setItem("uploadedFiles", JSON.stringify(files));
  }, [files]);

  return (
    <div className="additional-details-container">
      <div className="additionaldetailsScr">
        <div className="additionaldetails-header-container">
          <h3 className="title">Additional Details</h3>
          <div className="attachments-container">
            <img
              src="/images/attachment.png"
              alt="Attachment Icon"
              className="attachment-icon"
            />
            <label className="sub-title">Attachments</label>
          </div>
          <div className="form-container">
            <div className="row" {...getRootProps({ className: "dropzone" })}>
              <input {...getInputProps()} />
              <div className="upload-box">
                <img
                  src="/images/uploads.svg"
                  alt="Upload Icon"
                  className="upload-icon"
                />
                <p>Drag or Click to Upload</p>
                <p>PDF, Jpeg or PNG Files</p>
              </div>
            </div>
            <div className="row">
              <div className="file-list">
                {Array.isArray(files) &&
                  files.map((file, index) => (
                    <div key={index} className="file-item">
                      <img
                        src={file.image}
                        alt={`${file.name} preview`}
                        className="file-preview"
                      />
                      <span className="file-name">{file.name}</span>
                      <span className="file-size">{file.size}</span>
                      <div style={{ width: 50, height: 50 }}>
                        <CircularProgressbar
                          className="circular-progress"
                          value={file.progress}
                          text={`${file.progress}%`}
                          styles={buildStyles({
                            textSize: "32px",
                            pathColor: "#d72c16",
                            textColor: "#333",
                            trailColor: "#f0f0f0",
                          })}
                        />
                      </div>
                      <img
                        src="/images/bin.png"
                        alt="Delete Icon"
                        className="del-icon"
                        onClick={() => handleDelete(index)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalDetails;
